import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Stack from '@mui/material/Stack/Stack';
import { InputState } from '../InputState';
import { RejectOrderButton } from './RejectOrderButton';

type Option = {
    title: string;
    tooltip: string;
    scheduledEnabled: boolean;
};
const CONFIRM_STOCK: Option = {
    title: 'Confirmar stock',
    tooltip:
        'Al confirmar stock, se comparará tu distancia con la de otras farmacias cercanas al paciente y comenzará la cuenta regresiva.',
    scheduledEnabled: false,
};
const SCHEDULED_STOCK: Option = {
    title: 'Programar stock',
    tooltip:
        'En caso de falta de stock, podés pedir en droguería y programar la entrega para otro momento.',
    scheduledEnabled: true,
};

const BTN_WIDTH = 220;

function EmittedSubmitButton({
    setScheduleEnabled,
    inputState,
    orderId,
}: {
    setScheduleEnabled: (scheduledEnabled: boolean) => void;
    inputState: InputState;
    orderId: string;
}) {
    const handleScheduleButton = () => {
        setScheduleEnabled(true);
    };

    return (
        <Stack direction="row" spacing={2} justifyContent="space-between" width="100%">
            {/* REJECT BUTTON */}
            <RejectOrderButton orderId={orderId} inputState={inputState} />

            <Stack direction="row" spacing={2}>
                {/* SCHEDULE BUTTON */}
                <Tooltip
                    disableHoverListener={inputState === 'disabled'}
                    title={SCHEDULED_STOCK.tooltip}
                    enterDelay={1000}
                    placement="top">
                    <Button
                        onClick={handleScheduleButton}
                        size="medium"
                        variant="outlined"
                        sx={{ width: BTN_WIDTH }}
                        disabled={inputState === 'disabled'}
                        color={inputState === 'edit' ? 'secondary' : 'primary'}>
                        {SCHEDULED_STOCK.title}
                    </Button>
                </Tooltip>

                {/* CONFIRM BUTTON */}
                <Tooltip
                    disableHoverListener={inputState === 'disabled'}
                    title={CONFIRM_STOCK.tooltip}
                    enterDelay={1000}
                    placement="top">
                    <Button
                        type="submit"
                        size="medium"
                        variant="contained"
                        sx={{ width: BTN_WIDTH }}
                        disabled={inputState === 'disabled'}
                        color={inputState === 'edit' ? 'secondary' : 'primary'}>
                        {CONFIRM_STOCK.title}
                    </Button>
                </Tooltip>
            </Stack>
        </Stack>
    );
}

export { EmittedSubmitButton };
